import React, { Component } from "react";

export default class StartOverlay extends Component {
  render() {
    return (
      <div key="preEx" className="pre-ex">
        <div className="PreEx">
          <img src={this.props.img} alt="Exercise icon" width="80" />
          <h2>{this.props.name}</h2>
          <p>{this.props.title}</p>
          <p className="help-text" dangerouslySetInnerHTML={{__html: this.props.description}}></p>
          {this.props.advancedComponent && this.props.advancedComponent}
          <button
            id={this.props.btnId}
            className="ex-button yellow"
            style={{ fontSize: "26px" }}
            onClick={this.props.onClick}
          >
            {this.props.btnText}
          </button>
        </div>
      </div>
    );
  }
}
